import type { FaireProductEntity } from "../../entity_types/product";

export const p_8j33bdrl0j: FaireProductEntity = {
  token: "p_8j33bdrl0j",
  type: "product",
  name: "Moroccan Cone Jug - Amber",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/8b2f82739057e4dcf5a10843124ced8ed7662a7e3f060fbc89f1d110a9cefc31.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5936a308e5268eb5275d2ca4c5d8ba1a11e27d08bb0454a56e02019f623fb3ac.jpeg",
    "https://cdn.faire.com/fastly/540bd7fdeb4708e8a861975065c37e479556d5e0a0667304e918820860e53d57.jpeg",
    "https://cdn.faire.com/fastly/87f24e4d4463943db5c128c385053d06346d96ba7b5d76876347ee80d334ab02.jpeg",
    "https://cdn.faire.com/fastly/a6db4a9fbbd6509edad31830efbc85885f9ccedb1c5212139fba2264cba2d1d8.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
    "https://cdn.faire.com/fastly/676b1f0cf550452ffe3f8eeee7e546c06f87830183eeabca105290ff459b44c0.jpeg",
    "https://cdn.faire.com/fastly/31f1bc9434ccfbd465706f241902fa21b56542c3d409f6008d13d7c5a1bb2b45.jpeg",
  ],
  priceDollars: 23,
  description:
    "The sleek and simple design of these hand-blown cone-shaped jugs is a testament to the style and skill of the artisans who make them.  Used for all types of drinks, these jugs are a great compliment to any table setting adding color and culture to your table.\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and individual character of each piece.\n\nOur Moroccan glassware jugs come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nDishwasher safe.\n\n*Please note: handblown glass is sensitive to drastic temperature changes.",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:54.421Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
